import React, { Fragment, useEffect, useState } from 'react'
import { objectEntries, objectKeys } from 'ts-extras'
import type { HTMLElementProps } from '~/types'
import { cn, diffDates, Duration } from '~/utils'
import { useTranslations } from './Locale'

export interface CountdownProps extends HTMLElementProps<'span'> {
	to: Date
	rounding?: keyof Duration
	separatorClassName?: string
}

export const Countdown: React.FC<CountdownProps> = ({
	to,
	rounding,
	className,
	separatorClassName,
	children,
	...props
}) => {
	const [{ total, ...remaining }, setRemaining] = useState(diffDates(new Date(), to))
	useEffect(() => {
		const interval = setInterval(() => {
			setRemaining(diffDates(new Date(), to))
		}, 999)
		return () => clearInterval(interval)
	}, [to])
	const t = useTranslations('react.units')

	const lastIndex = objectKeys(remaining).findIndex(unit => unit === rounding)
	if (total <= 0) return null
	return (
		<span className={cn('m-0 rounded-2xl text-[1.25em] font-semibold', className)} {...props}>
			{children}
			{objectEntries({ ...remaining })
				.filter((_, i) => (lastIndex >= 0 ? i <= lastIndex : true))
				.map(([unit, value]) => (
					<Fragment key={unit}>
						<span>{value}</span>
						<span className="text-e7/8">{t?.[`${unit}_short`]}</span>
						<span className={cn('mx-1 last:hidden', separatorClassName)}>:</span>
					</Fragment>
				))}
		</span>
	)
}
